import { render, staticRenderFns } from "./ServletMappings.vue?vue&type=template&id=4ee42448&"
import script from "./ServletMappings.vue?vue&type=script&lang=js&"
export * from "./ServletMappings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports